import { ResourcesApi } from "../api/api";
import { useQuery } from "react-query";
import { Configuration } from "../api/configuration";
import { FetchedResourcePlan } from "../types/fetchedResourcePlan";

export type Props = {
  basePath: string;
  customerId: string;
  resourceId: string;
};

const useFetchResourcePlansByResource = ({ basePath, customerId, resourceId }: Props) => {
  const resourcesApi = new ResourcesApi(new Configuration({ basePath }));
  const {
    data: plans,
    isLoading,
    isFetching,
  } = useQuery<FetchedResourcePlan[]>("resourcePlans", async () => {
    const res = await resourcesApi.allResourcePlansByResource(customerId, resourceId);
    return res.data;
  });

  return { plans, isLoading, isFetching };
};

export default useFetchResourcePlansByResource;
